export enum EventViewCategories {
  BurstMainLeak = 'BurstMainLeak',
  OtherLeak = 'OtherLeak',
  Alarm = 'Alarm',
  Activity = 'Activity',
  MeterFault = 'MeterFault',
}
